import { render } from "./SupportList.vue?vue&type=template&id=cc1fe33c&scoped=true"
import script from "./SupportList.vue?vue&type=script&lang=js"
export * from "./SupportList.vue?vue&type=script&lang=js"

import "./SupportList.vue?vue&type=style&index=0&id=cc1fe33c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1fe33c"]])

export default __exports__